import Vue from "vue" 
export default {
    GO_TO( state, {section, response} ){
        Vue.set(state, "current", {section, response} )
    },
    HIDE_ANSWERED(state, value ){
        Vue.set(state, "hide_answered", value );
    }
}